// PRD §3.7 — Spanish ISO 11784 cattle ear-tag (crotal) validator.
// Format: "ES" + 13 digits, last digit is a mod-10 weighted checksum
// using alternating weights [3,1,3,1,3,1,3,1,3,1,3,1] over the leading 12.
//
// Apply BEFORE prisma.animal.create. V2 will additionally cross-check the
// crotal against MAPA/SITRAN to verify ownership of the declared exploitation.
const WEIGHTS = [3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1];
export const CROTAL_REGEX = /^ES\d{13}$/;
export function validateSpanishCrotalId(crotalId) {
    if (typeof crotalId !== 'string' || !CROTAL_REGEX.test(crotalId)) {
        return { valid: false, reason: 'Formato inválido. Debe ser ES + 13 díxitos.' };
    }
    const digits = crotalId.slice(2).split('').map(Number);
    const checkDigit = digits[12];
    const leading = digits.slice(0, 12);
    const sum = leading.reduce((acc, d, i) => acc + d * WEIGHTS[i], 0);
    const calculated = (10 - (sum % 10)) % 10;
    if (calculated !== checkDigit) {
        return { valid: false, reason: `Díxito de control inválido. Esperado: ${calculated}` };
    }
    return { valid: true };
}
/**
 * Compute the correct check digit for a 14-character ES crotal stem
 * (e.g. "ES" + 12 digits). Useful for fixtures and tests.
 */
export function computeCrotalCheckDigit(stem) {
    if (!/^ES\d{12}$/.test(stem)) {
        throw new Error('Stem must be "ES" + exactly 12 digits.');
    }
    const digits = stem.slice(2).split('').map(Number);
    const sum = digits.reduce((acc, d, i) => acc + d * WEIGHTS[i], 0);
    return (10 - (sum % 10)) % 10;
}
//# sourceMappingURL=crotal.js.map